import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import API from '../api/api';
import BusyOverlay from './BusyOverlay';
import CreateBookingDialog from './CreateBookingDialog';
import DeleteBookingDialog from './DeleteBookingDialog';
import EditCommentForm from './EditCommentForm';
import './style/ReservationList.css';


class ReservationList extends React.Component {
    static propTypes = {
        config: PropTypes.object
    }
    state = {
        busy: false,
        currentBoat: "",
        currentMonth: moment(),
        bookings: [],
        bookingPopup: null,
        deletePopup: null,
        commentPopup: null,
    }
    componentDidMount() {
        this.setState({currentBoat: Object.keys(this.props.config.boats)[0]})
        this.refresh();
    }
    componentDidUpdate(prevProps, prevState) {
        if(this.state.currentBoat !== prevState.currentBoat || this.state.currentMonth !== prevState.currentMonth) {
            this.setState({
                bookings: {},
                bookingPopup: null,
                deletePopup: null,
                commentPopup: null
            });
            this.refresh();
        }
    }
    constructor(props) {
        super(props);
        this.slotLabels = {
            'morning': 'Mattino ( - 12:00)',
            'afternoon': 'Pomeriggio (12:00 - 17:00)',
            'evening': 'Sera (17:00 - )'
        };
    }
    render() {
        return (
            <div key="Calendar" className="reservation-list-container">
                <div className="reservation-list-header">
                    {this.renderBoatPicker()}
                    {this.renderMonthPicker()}
                    {process.env.NODE_ENV !== 'production' ? (<span className="reservation-list-header-dev">DEVELOPMENT</span>): null}
                </div>
                <div className="reservation-list-body">
                    {[...Array(this.state.currentMonth.daysInMonth()).keys()].map((idx) => this.renderDay(idx + 1))}
                </div>
                {this.state.bookingPopup ? (<CreateBookingDialog config={this.props.config} boat={this.state.currentBoat} date={this.state.bookingPopup.date} slot={this.state.bookingPopup.slot} onClose={this.bookingPopupClosed} />) : null}
                {this.state.deletePopup ? (<DeleteBookingDialog config={this.props.config} boat={this.state.currentBoat} date={this.state.deletePopup.date} slot={this.state.deletePopup.slot} member={this.state.deletePopup.member} onClose={this.deletePopupClosed} />) : null}
                {this.state.busy ? (<BusyOverlay key="busyOverlay" type="fullscreen" />) : null}
            </div>
        );
    }
    renderBoatPicker = () => {
        return (
            <span className="reservation-list-picker">
                <span>Barca: </span>
                <select value={this.state.currentBoat} onChange={ev => this.setBoat(ev.target.value)}>
                    {Object.entries(this.props.config.boats).map(([key, value]) => (
                        <option key={key} value={key}>{value}</option>
                    ))}
                </select>
            </span>
        );
    }
    renderMonthPicker = () => {
        let months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
        return (
            <span className="reservation-list-picker">
                <span>Periodo: </span>
                <select value={this.state.currentMonth.month()} onChange={ev => this.setMonth(ev.target.value)}>
                    {months.map((entry, idx) => (
                        <option key={idx} value={idx}>{entry}</option>
                    ))}
                </select>
                <span className="reservation-list-year">
                    {moment().year()}
                </span>
            </span>
        );
    }
    setBoat = (boat) => {
        this.setState({
            currentBoat: boat,
        });
    }
    setMonth = (month) => {
        this.setState({
            currentMonth: this.state.currentMonth.clone().month(month),
        });
    }
    renderDay = (day) => {
        let date = moment(this.state.currentMonth).date(day);
        return (
            <div key={"day" + day}>
                <div>
                {day}
                </div>
                <div>
                    {Object.keys(this.props.config.daySlots).map(slot => this.renderDaySlot(date, slot))}
                </div>
            </div>
        );
    }
    renderDaySlot = (date, slot) => {
        let booking = (this.state.bookings[date.format('YYYYMMDD')] || {})[slot];
        let commentBox = null;
        if(booking && this.state.commentPopup && this.state.commentPopup.date.format('YYYYMMDD') === date.format('YYYYMMDD') && this.state.commentPopup.slot === slot) {
            commentBox = (
                <EditCommentForm boat={this.state.currentBoat} date={date} slot={slot} comment={booking.comment} onClose={this.commentPopupClosed} />
            );
        } else if(booking) {
            commentBox = (<input type="text" placeholder="Osservazioni, danni, ..." onClick={(ev) => this.editComment(date, slot, booking.member)} value={booking.comment} onChange={ev => {}} />);
        }
        return (
            <div key={slot}>
                <span>{this.props.config.daySlots[slot]}</span>
                <span>{booking ? (
                        <span onClick={(ev) => this.deleteSlot(date, slot, booking.member)}>{booking.member.membernr + " - " + booking.member.firstname + " " + booking.member.lastname}</span>
                    ) : (<button onClick={(ev) => this.bookSlot(date, slot)}>Prenota</button>)}</span>
                <span>{commentBox}</span>
            </div>
        );
    }
    bookSlot = (date, slot) => {
        this.setState({bookingPopup: {date, slot}});
    }
    deleteSlot = (date, slot, member) => {
        this.setState({deletePopup: {date, slot, member}});
    }
    editComment = (date, slot, member) => {
        this.setState({commentPopup: {date, slot}});
    }
    submitComment = (ev, date, slot) => {
        ev.preventDefault();
        console.log(ev);
        this.setState({commentPopup: null});
    }
    bookingPopupClosed = (refresh) => {
        this.setState({bookingPopup: null});
        if(refresh) {
            this.refresh();
        }
    }
    deletePopupClosed = (refresh) => {
        this.setState({deletePopup: null});
        if(refresh) {
            this.refresh();
        }
    }
    commentPopupClosed = (refresh) => {
        this.setState({commentPopup: null});
        if(refresh) {
            this.refresh();
        }
    }
    refresh = () => {
        let start = moment(this.state.currentMonth)
        start.subtract(1,'months').startOf('month');
        let end = moment(this.state.currentMonth)
        end.add(1,'months').endOf('month');
        this.setState({busy: true});
        API.getBookings(this.state.currentBoat, start, end, (bookings) => {
            this.setState({bookings: bookings, busy: false});
        });
    }
};

export default ReservationList;
